import { CrudForm } from "#pub/crud/index.js";
import LoginFormConfig from "./config/LoginFormConfig.js";

export default {

    extends: CrudForm,

    name: 'LoginForm',

    config: LoginFormConfig
}